import axios from 'axios';



const NewaccessToken = localStorage.getItem("NewaccessToken")


const instance = axios.create({
    baseURL: 'https://backend-vidyalayam.v6hisj.easypanel.host/api/',
    timeout: 5000,
    headers: {
        // 'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        Authorization: NewaccessToken,
    },
});

export const noauthinstance = axios.create({
    baseURL: 'https://backend-vidyalayam.v6hisj.easypanel.host/api/',
    timeout: 5000,
    headers: {
        // 'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        Authorization: NewaccessToken,
    },
});

//Add a request interceptor
// instance.interceptors.request.use(
//     (config) => {
//         const userToken = getUserToken(); // Implement this function to retrieve the user token

//         if (userToken) {
//             config.headers.Authorization = `Bearer ${userToken}`;
//         }
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

export default instance;
